import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message/MessageSlice';
import MailSettingsService from '../../../service/settings/MailSettings';

// ===============================
// 🔹 Get Mail Settings List
// ===============================
export const getMailSettingsList = createAsyncThunk(
  'MailSettingsSlice/getMailSettingsList',
  async (_, thunkAPI) => {
    try {
      const response = await MailSettingsService.getMailSettingsList();

      return {
        MailSettingsList: response.data.aaData, // ✅ correct field
        totalRecords: response.data.iTotalRecords,
      };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();

      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

// ===============================
// 🔹 Save Mail Settings
// ===============================
export const saveMailSettingsList = createAsyncThunk(
  'MailSettingsSlice/saveMailSettingsList',
  async (data, thunkAPI) => {
    debugger;
    try {
      const response = await MailSettingsService.saveMailSettingsList(data);

      // thunkAPI.dispatch(setMessage(response.data.msg));
      thunkAPI.dispatch(setMessage({ message: response.data.msg, type: 'success' }));
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();

      thunkAPI.dispatch(setMessage({ message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  },
);

// ===============================
// 🔹 Slice
// ===============================
const MailSettingsSlice = createSlice({
  name: 'MailSettingsSlice',
  initialState: {
    MailSettingsList: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // ================= GET LIST =================
      .addCase(getMailSettingsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMailSettingsList.fulfilled, (state, action) => {
        state.loading = false;
        state.MailSettingsList = action.payload.MailSettingsList;
        state.totalRecords = action.payload.totalRecords;
      })
      .addCase(getMailSettingsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.MailSettingsList = [];
      })

      // ================= SAVE =================
      .addCase(saveMailSettingsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveMailSettingsList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(saveMailSettingsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default MailSettingsSlice.reducer;
